import { Link } from "react-router-dom";
import { ClipboardList, Workflow, ShieldCheck, ArrowRight } from "lucide-react";
import TopBar from "@/components/TopBar";
import { useAuth } from "@/context/AuthContext";

const Card = ({ to, icon: Icon, title, desc, testid }) => (
  <Link to={to} data-testid={testid} className="card-surface p-6 group hover:shadow-lg transition-shadow flex flex-col">
    <span className="section-badge mb-4" style={{ background: "rgba(106,20,46,0.10)", color: "var(--burgundy)" }}>
      <Icon className="w-6 h-6" />
    </span>
    <p className="text-lg font-semibold text-[var(--burgundy)]">{title}</p>
    <p className="text-sm text-neutral-500 mt-1 flex-1">{desc}</p>
    <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-[var(--burgundy)] group-hover:gap-2 transition-all">
      Open <ArrowRight className="w-4 h-4" />
    </span>
  </Link>
);

export default function Home() {
  const { user } = useAuth();
  const canOrch = user?.role === "admin" || user?.role === "operator";
  return (
    <div className="min-h-screen" data-testid="home-page">
      <TopBar />
      <div className="max-w-5xl mx-auto px-5 sm:px-8 pt-12">
        <p className="text-[11px] tracking-[0.22em] text-amber-700/80 font-semibold uppercase">MikadoComms · Wema Bank IAM</p>
        <h1 className="text-3xl sm:text-4xl font-bold mt-1" style={{ color: "var(--burgundy)" }}>Choose a tool</h1>
        <p className="text-neutral-500 mt-2 text-sm max-w-2xl">Three connected workspaces for discovery, profiling and automated provisioning. Pick where you want to work.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
          <Card to="/IAMquestionnaire" icon={ShieldCheck} testid="home-card-iam"
            title="IAM Profiling Questionnaire" desc="Capture how each application is currently profiled — the per-application access walkthrough." />
          <Card to="/onboarding" icon={ClipboardList} testid="home-card-onboarding"
            title="Onboarding Workflow Discovery" desc="Map the end-to-end new-hire onboarding process across departments, apps and approvals." />
          {canOrch && (
            <Card to="/orchestration" icon={Workflow} testid="home-card-orchestration"
              title="Provisioning Orchestration" desc="Fan one access request into per-application tasks and drive each connector to completion." />
          )}
        </div>
      </div>
    </div>
  );
}
